module.exports = __webpack_public_path__ + "static/media/r5.430f0dec.png";